import { CDN_URL } from '@core/config';

const defaultSizes = [480, 600, 980, 1280, 1920];
export const imageSizes = {
  default: defaultSizes,
  sm: [480, 600, 980, 1280],
  avatar: [50, 120, 240, 480],
  session: defaultSizes,
};

export type FileInfo = {
  name: string;
  extension: string;
};
const cdn = CDN_URL;
export const isCDN = (src: string) => cdn && src.startsWith(cdn);

export const getImageInfo = (src: string | undefined): FileInfo | undefined => {
  if (!src) return undefined;
  const i = src.lastIndexOf('.');
  return {
    name: src.substring(0, i),
    extension: src.substring(i),
  };
};

export const buildImage = (fileInfo: FileInfo | undefined, size: number): string | undefined =>
  fileInfo ? `${fileInfo.name}${size ? `.${size}w` : ''}${fileInfo.extension}` : undefined;

export const buildImageSrc = (
  src: Maybe<string>,
  size: number,
  fallback = false,
): string | undefined => {
  if (!src || !isCDN(src)) return src ?? undefined;
  const fileInfo = getImageInfo(src);
  const newSrc = buildImage(fileInfo, size);
  if (!fallback) return newSrc;
  return newSrc ?? src ?? undefined;
};

export const buildSrcSet = (src: Maybe<string>, sizes: number[]): string | undefined => {
  if (!src || !isCDN(src)) return src ?? undefined;
  const fileInfo = getImageInfo(src);
  return fileInfo
    ? sizes.map((size) => `${buildImage(fileInfo, size)} ${size}w`).join(',')
    : undefined;
};
